define(
  ['jquery', 'underscore', 'backbone.marionette'],
  function ($, _, Marionette) {
    var loadComponents = function (components) {
      var self = this
      if (!self._components_loaded) {
        self.components = {}
        self._components_loaded = true
      } else {
        return false
      }
      _.each(components, function (component, instanciateIn) {
        if (_.isFunction(component)) component = component.call(self)
        var el

        if (_.isString(component.el)) {
          if (component.el.indexOf('@ui.') > -1) {
            el = self.ui[component.el.replace('@ui.', '')]
          } else {
            el = self.$el.find(component.el)
          }
        } else {
          el = component.el
        }

        window.app.init(
          {
            component: component.name,
            el: el,
            data: component.data,
            extend: component.extend
          },
          function (instance) {
            self.triggerMethod(
              'component:' + instanciateIn + ':loaded',
              instance
            )
            self.components[instanciateIn] = instance
          }
        )
      })
    }
    var _olView = Marionette.View

    $.fn.getView = function (cb) {
      if (this._instance) {
        cb(this._instance)
        return this
      }

      $(this).on('view:mounted', function (instance) {
        return cb(instance.target._instance)
      })
    }

    Marionette.View = Marionette.View.extend({
      constructor: function () {
        var self = this
        _olView.apply(self, arguments)
        if (self.components) {
          self.loadComponents = loadComponents
          self.listenTo(self, 'render', function () {
            self.loadComponents(self.components)
          })
        } else {
          self.components = false
        }

        $(self.$el || self.el).each(function (index, elem) {
          elem._instance = self
          $(elem).trigger('view:mounted', self)
        })
      }
    })

    Marionette.AttachView = Marionette.ItemView.extend({
      render: function () {
        this.triggerMethod('before:render', this)
        this.triggerMethod('item:before:render', this)

        this.bindUIElements()

        this.triggerMethod('render', this)
        this.triggerMethod('item:rendered', this)

        return this
      }
    })

    return Marionette
  }
)
